import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]查询理财首页三大方向
 */
export function queryThreeDirectUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultThreeDirectColumnDto> {
  return resource.postNoAuth('/threeDirect/queryThreeDirect', req, config);
}

/**
 * [No Auth]查询理财首页三大方向详情
 */
export function queryThreeDirectDetailUsingPOST(
  req: ThreeDirctDetailParam | void,
  config?: RequestConfig
): Promise<ApiResultListThreeDirectDto> {
  return resource.postNoAuth('/threeDirect/queryThreeDirectDetail', req, config);
}
